import ButtonComponent from '../stories/atoms/button'
import {
  buttonSideOptions,
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../stories/atoms/button/constants'
import { Confirm } from '../stories/atoms/icons/essentials'
import { iconSizeOptions } from '../stories/atoms/icons/icons-sizes'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import { motion } from 'framer-motion'
import { ButtonOnlyIconContainer } from './styled-components'
import PropTypes from 'prop-types'

const ConfirmIcon = ({ isActive }) => (
  <motion.div
    initial={false}
    animate={{
      opacity: isActive ? 1 : 0,
      scale: isActive ? 1 : 0.5,
      width: isActive ? 'auto' : 0
    }}
    transition={{ duration: 0.15 }}
    style={{ display: 'flex', overflow: 'hidden' }}
  >
    <Confirm
      size={iconSizeOptions['ICON-S']}
      stroke={colorsOptions.docuToolsOrange.orange}
    />
  </motion.div>
)

const ListViewButton = ({ isActive, Icon, onClick, isLeft }) => {
  const buttonSide = isLeft ? buttonSideOptions.LEFT : buttonSideOptions.RIGHT

  return (
    <ButtonComponent
      variant={buttonVariantOptions['SIDE-IMAGE-OVERLAY']}
      size={buttonSizeOptions.MEDIUM}
      buttonType={buttonTypeOptions['ICON-ONLY']}
      side={buttonSide}
      backgroundColor={colorsOptions.greys.white}
      disableIconStyle
      style={{
        border: `1px solid ${colorsOptions.greys['grey-30']}`
      }}
      onClick={onClick}
    >
      <ButtonOnlyIconContainer>
        <ConfirmIcon isActive={isActive} />

        <Icon
          stroke={isActive ? colorsOptions.docuToolsOrange.orange : undefined}
        />
      </ButtonOnlyIconContainer>
    </ButtonComponent>
  )
}

ListViewButton.propTypes = {
  isActive: PropTypes.bool,
  Icon: PropTypes.elementType,
  onClick: PropTypes.func,
  isLeft: PropTypes.bool
}

export default ListViewButton
